export function valueToThemeColor(value?: number, base: number = 100) {
  if (typeof value !== "number") return "gray"

  const val = Math.round((value / base) * 100)
  return val > 75 ? "green" : val > 50 ? "lime" : val > 25 ? "yellow" : val > 0 ? "orange" : "red"
}
